export const getNavItems = (chapter) => {
  const navItems = [
    {
      path: '#class-info',
      label: 'Class Info',
    },
  ]

  if (chapter?.chapterStructuredData?.articleBody) {
    navItems.unshift({
      path: '#transcript',
      label: 'Preview',
    })
  }

  return navItems
}
